import { ApiBase } from 'utils/api';
import { objectToFormData } from 'utils/common';


export default class ChatApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    };

    list = (closed: boolean = false) => {
        return this.base.axios.get('/api/chat', {params: {closed}});
    };

    createOrGet = (code: string, name: string) => {
        return this.base.axios.get(`/api/chat/${code}?name=${name}`)
    };

    createCustom = (code: string, name: string, userIds: string[]) => {
        return this.base.axios.post(`/api/chat/${code}`, {name, userIds})
    };

    send = (code: string, text: string, attachments?: File[]) => {
        return this.base.axios.post(`/api/chat/${code}`,
            objectToFormData({
                text,
                attachments,
            }),
            {
                _silently: true,
                headers: {'Content-Type': 'multipart/form-data'},
            }
        )
    };

    prev = (code: string, time: string) => {
        return this.base.axios.get(`/api/chat/${code}?cursor=${time}`)
    };

    close = (code: string) => {
        return this.base.axios.delete(`/api/chat/${code}`)
    };

    unread = () => {
        return this.base.axios.get(`/api/chat/unread`)
    }
}
